export default __webpack_public_path__ + "static/media/shippedIconRed.d86919fe.svg";